import dayjs from 'dayjs';
import { ITask } from '../../interface/tasks';

export const isCriticalTaskFormChanged = (
  task: ITask | null | undefined,
  initialTask: ITask | null | undefined,
  isEditMode: boolean,
): boolean => {
  if (!isEditMode) {
    return (
      !!task?.matter?.id ||
      !!task?.otherResponsibleUsers?.length ||
      !!task?.currentSubject ||
      !!task?.description ||
      dayjs(task?.dueTime).format('YYYY-MM-DD') !==
        dayjs(initialTask?.dueTime).format('YYYY-MM-DD') ||
      dayjs(task?.startTime).format('YYYY-MM-DD') !==
        dayjs(initialTask?.startTime).format('YYYY-MM-DD') ||
      (task?.alertTime ? task?.alertTime : null) !== (initialTask?.alertTime ?? null)
    );
  }

  const otherResponsibleUsers = (task?.otherResponsibleUsers ?? []).map((user) => user.user.id);
  const initialOtherResponsibleUsers = (initialTask?.otherResponsibleUsers ?? []).map(
    (user) => user.user.id,
  );
  const otherResponsibleUsersMatch =
    otherResponsibleUsers.length === initialOtherResponsibleUsers.length &&
    otherResponsibleUsers.every((value) => initialOtherResponsibleUsers.includes(value));
  const alertTimeMatches =
    (task?.alertTime ? task?.alertTime : null) === (initialTask?.alertTime ?? null);
  return (
    task?.matter?.id !== initialTask?.matter?.id ||
    task?.currentSubject !== initialTask?.subject ||
    (task?.description || null) !== (initialTask?.description || null) ||
    task?.status?.id !== initialTask?.status?.id ||
    task?.priority !== initialTask?.priority ||
    dayjs(task?.dueTime).format('YYYY-MM-DD') !==
      dayjs(initialTask?.dueTime).format('YYYY-MM-DD') ||
    dayjs(task?.startTime).format('YYYY-MM-DD') !==
      dayjs(initialTask?.startTime).format('YYYY-MM-DD') ||
    !alertTimeMatches ||
    !otherResponsibleUsersMatch
  );
};
